import React, { Component } from 'react'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  inject,
  observer
} from '../../../helper/devTools.js'
/* import config from 'src/core/config'
import vs from '../../../helper/vconsole' */
import Message from '../../../component/Message'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ludoStore = this.props.store.register('ludo/main')
    setDocumentTitle(`Rank`)
  }
  state = {
    lang: {},
    messageTxt: "",
    tabStatus: 1,
    // 用于保存更改
    todayList: [],
    yesList: [],
    monthList: [],
    todayMy: {},
    yesMy: {},
    monthMy: {},
    langugae:'en',
    // 初始化
    showList: [],
    showMyRank: {},
    topOne: {},
    topTwo: {},
    topThree: {},
    type:1,
  }
  async componentDidMount() {

    try {
      let url = window.location.href.split('?')[1]
      console.log('my url' ,url)
      let arr =  url.split('=')
      arr && arr[1] && await this.setState({type:arr[1]*1 })
    } catch (error) {
      
    }
    
    this.initLang()
    let uid = await this.initUid()
    this.getData()
    await this.RunOnStart(uid)

  }
  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, this.ludoStore.data.lang),
      language: language,
    })
    console.log('language', language)
    
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async getData() {
    let {type} = this.state
    let todayList = await this.ludoStore.apiGetLudoRank(0,type)
    console.log('%c [ todayList ]-69', 'font-size:20px; background:pink; color:#bf2c9f;', todayList)
    console.log('%c [  todayList.res ]-82', 'font-size:20px; background:pink; color:#bf2c9f;', todayList.res)

    let yesList = await this.ludoStore.apiGetLudoRank(1,type)
    let monthList = await this.ludoStore.apiGetLudoMonthRank(0,type)
    this.setState({
      // 用于保存更改todayList && todayList.res && todayList.res.list
      todayList: todayList && todayList.res && todayList.res.list,
      yesList: yesList && yesList.res && yesList.res.list,
      todayMy: todayList && todayList.res && todayList.res.myrank,
      yesMy: yesList && yesList.res && yesList.res.myrank,
      monthList: monthList && monthList.res && monthList.res.list,
      monthMy: monthList && monthList.res && monthList.res.myrank,

      // 初始化
      showList: todayList && todayList.res && todayList.res.list || [],
      showMyRank: todayList && todayList.res && todayList.res.myrank,
      topOne: todayList && todayList.res && todayList.res.list[0],
      topTwo: todayList && todayList.res && todayList.res.list[1],
      topThree: todayList && todayList.res && todayList.res.list[2],
    })

    
  }



  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // try {
    //   this.setState({
    //     uid: uid
    //   })
    //   let getUserInfo = await this.ludoStore.GetUserInfoWeb(uid)
    //   if (getUserInfo && getUserInfo.code == 0) {
    //     this.setState({
    //       userInfo: getUserInfo.res
    //     })
    //   }
    // } catch (error) {
    //   console.error(error)
    //   this.refs.msg.show("error")
    // }
  }

  handleTab(type) {
    
    if (type == 1) {
      this.setState({
        tabStatus: 1,
        showList: this.state.todayList,
        showMyRank: this.state.todayMy,
        topOne: this.state.todayList[0],
        topTwo: this.state.todayList[1],
        topThree: this.state.todayList[2],
      })
    }
    if (type == 2) {
      this.setState({
        tabStatus: 2,
        showList: this.state.yesList,
        showMyRank: this.state.yesMy,
        topOne: this.state.yesList[0],
        topTwo: this.state.yesList[1],
        topThree: this.state.yesList[2],
      })
    }
    if (type == 3) {
      this.setState({
        tabStatus: 3,
        showList: this.state.monthList,
        showMyRank: this.state.monthMy,
        topOne: this.state.monthList[0],
        topTwo: this.state.monthList[1],
        topThree: this.state.monthList[2],
      })
    }
    window.document.documentElement.scrollTop = 0
  }

  render() {
    return (
      <div className={`ludo-rank-container`}>

        <div style={{ display: "none" }}>
          <img src="/img/ludo/rank/t1.png" alt="" />
          <img src="/img/ludo/rank/t2.png" alt="" />
          <img src="/img/ludo/rank/t3.png" alt="" />
        </div>

        <Message ref="msg" />
        <div className="big-bg"></div>
        <div className="show-tab" style={{ direction: `${this.state.language == "ar" ? "rtl" : "ltr"}` }}>
          <div className={`tab-item ${this.state.tabStatus == 1 && "tab-item-active"}`} onClick={() => { this.handleTab(1) }}>
            {this.state.lang.today}
          </div>
          <div className={`tab-item ${this.state.tabStatus == 2 && "tab-item-active"}`} onClick={() => { this.handleTab(2) }}>
            {this.state.lang.yes}
          </div>
          <div className={`tab-item ${this.state.tabStatus == 3 && "tab-item-active"}`} onClick={() => { this.handleTab(3) }}>
            {this.state.lang.month}
          </div>
        </div>
        <div className="top-banner">
          {
            this.state.topOne && this.state.topOne.uid > 0 && (
              <div className="top1">
                <img className='avatar' src={this.state.topOne && this.state.topOne.avatarurl} alt="" />
                <img className='head' src="/img/ludo/rank/t1.png" alt="" />
              </div>
            )
          }
          {
            this.state.topTwo && this.state.topTwo.uid > 0 && (
              <div className="top2">
                <img className='avatar' src={this.state.topTwo && this.state.topTwo.avatarurl} alt="" />
                <img className='head' src="/img/ludo/rank/t2.png" alt="" />
              </div>
            )
          }
          {
            this.state.topThree && this.state.topThree.uid > 0 && (
              <div className="top3">
                <img className='avatar' src={this.state.topThree && this.state.topThree.avatarurl} alt="" />
                <img className='head' src="/img/ludo/rank/t3.png" alt="" />
              </div>
            )
          }
          <div className="top-stage">
            <div className="t1">{this.state.topOne && this.state.topOne.nickname}</div>
            <div className="t2">{this.state.topTwo && this.state.topTwo.nickname}</div>
            <div className="t3">{this.state.topThree && this.state.topThree.nickname}</div>
          </div>
        </div>
        <div className="rank-items" style={{ direction: `${this.state.language == "ar" ? "rtl" : "ltr"}` }}>
          {
            this.state.showList.map((i, k) => {
              if (k > 2) {
                return (
                  <div className="item" key={k} style={{ "--deg": `${this.state.language == "ar" ? "180deg" : "0"}` }}>
                    <div className="rank-index">{i.rank}</div>
                    <div className="user-info">
                      <div className="info">
                        <img className='ava' src={i.avatarurl} alt="" />
                        <div className="name">{i.nickname}</div>
                      </div>
                      <div className="gold">
                        <img src="/img/ludo/rank/gold.png" alt="" />
                        <span>{i.val}</span>
                      </div>
                    </div>
                  </div>
                )
              }
            })
          }
        </div>
        <div className="my-rank-box" style={{ direction: `${this.state.language == "ar" ? "rtl" : "ltr"}` }}>
          <div className="rank-index">{this.state.showMyRank && this.state.showMyRank.rank}</div>
          <div className="user-info">
            <div className="info">
              <img className='ava' src={this.state.showMyRank && this.state.showMyRank.avatarurl} alt="" />
              <div className="name">{this.state.showMyRank && this.state.showMyRank.nickname}</div>
            </div>
            <div className="gold">
              <img src="/img/gold.png" alt="" />
              <span>{this.state.showMyRank && this.state.showMyRank.val}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/ludo/ludorank/index.js